import React from "react";
import { Box, Group, Text } from "@mantine/core";
import { ClientGroupType } from "../../../types/clientGroups";

/**
 * Group type marker (design §5.1 cell 2). The Sales `StatusCell` is bound to
 * sales statuses, so this is the Client Groups equivalent: `Dynamic` is the
 * exception and takes the teal pill; `Static` is quiet — a grey dot + label.
 */
export default function GroupTypeCell({ type }: { type: ClientGroupType }) {
  if (type === "dynamic") {
    return (
      <Box
        component="span"
        style={{
          justifySelf: "start",
          display: "inline-block",
          padding: "4px 9px",
          fontSize: 10,
          fontWeight: 600,
          letterSpacing: ".04em",
          textTransform: "uppercase",
          borderRadius: 999,
          color: "var(--brand-teal)",
          background: "rgba(54, 175, 201, 0.12)",
        }}
      >
        Dynamic
      </Box>
    );
  }
  return (
    <Group gap={7} wrap="nowrap" style={{ justifySelf: "start" }}>
      <Box
        style={{
          width: 6,
          height: 6,
          borderRadius: 999,
          background: "#c9c9c9",
        }}
      />
      <Text size="13px" c="dimmed">
        Static
      </Text>
    </Group>
  );
}
